import type { SiteImage } from '../types/content';

/*
 * Image library.
 * 'representative' = illustrative image, NOT a photograph of a Liftoff project.
 * When original project photographs are extracted from the profile and banners,
 * add them here with source: 'project' and reference them from the project records.
 */
const representative = (src: string, alt: string): SiteImage => ({ src, alt, source: 'representative' });

export const heroImages = {
  roads: representative(
    'https://cdn.magicpatterns.com/uploads/fsanPmVPrerXVXubCDnoRQ/Sunset_Excavators_on_a_Muddy_Worksite.png',
    'Excavator and bulldozer working on an earthworks site at sunset',
  ),
  water: representative(
    'https://cdn.magicpatterns.com/uploads/7aB8GMGo2KrR1Yu2AUVKQ6/Industrial_Towers_and_Cranes_Construction_Site.png',
    'Two mobile cranes lifting elevated steel water tanks onto their towers',
  ),
  equipment: representative(
    'https://cdn.magicpatterns.com/uploads/kayEifkmjkU1vzyE5Mqywf/Construction_Equipment_Yard_Panorama.png',
    'Road rollers, an excavator and trucks lined up in a construction plant yard',
  ),
};

export const images = {
  roadGrader: representative(
    'https://cdn.magicpatterns.com/patterns/generated-images/3e94f876-0f9e-459c-aeac-a9547ddeea56.jpg',
    'Motor grader shaping a gravel road base through dry savannah',
  ),
  waterBowser: representative(
    'https://cdn.magicpatterns.com/patterns/generated-images/d5175e5d-206d-4133-bc64-1e708249c0a5.jpg',
    'Water bowser spraying a gravel road layer ahead of a grader',
  ),
  pipework: representative(
    'https://cdn.magicpatterns.com/patterns/generated-images/cd24bec9-2835-496e-a134-56cbb4aa5c0c.jpg',
    'Blue ductile pipework and valves inside a water pump station',
  ),
  sewerStation: representative(
    'https://cdn.magicpatterns.com/patterns/generated-images/291baa48-1ad3-4a21-892d-391f3e194468.jpg',
    'Vacuum vessel, pipework and vacuum pumps inside a sewer pump station',
  ),
  buildingWorks: representative(
    'https://cdn.magicpatterns.com/patterns/generated-images/7865e35b-32c7-470a-9ea5-3cce974d9918.jpg',
    'Double-storey face-brick building under construction with scaffolding',
  ),
  culvert: representative(
    'https://cdn.magicpatterns.com/patterns/generated-images/721ebbb6-f3fd-42a5-b662-0cb98f68565f.jpg',
    'Excavator lowering precast concrete box culverts into a drainage trench',
  ),
  paving: representative(
    'https://cdn.magicpatterns.com/patterns/generated-images/203b09f2-9162-40e4-bc04-e4270648981f.jpg',
    'Interlocking paved access road and car park outside a public building',
  ),
  miningSlope: representative(
    'https://cdn.magicpatterns.com/patterns/generated-images/50861a50-a3b5-4062-a11f-b6ea646449d3.jpg',
    'Workers in protective clothing inspecting terraced slopes of an open-pit boxcut',
  ),
  tipperTrucks: representative(
    'https://cdn.magicpatterns.com/patterns/generated-images/19db889f-2abe-41f7-9095-a168d960e5f1.jpg',
    'Fleet of white and red tipper trucks parked in a construction yard',
  ),
  concreteMixer: representative(
    'https://cdn.magicpatterns.com/patterns/generated-images/cb0ec676-ca46-40ab-b89e-d6695d199d08.jpg',
    'Portable diesel concrete mixer on a building site',
  ),
  surveyor: representative(
    'https://cdn.magicpatterns.com/patterns/generated-images/e03c4c64-1664-4fc8-ac7e-02ac1fbccbf2.jpg',
    'Total station on a tripod with a surveyor holding a staff on a road site',
  ),
  backhoe: representative(
    'https://cdn.magicpatterns.com/patterns/generated-images/b882550e-dd78-4d55-a16e-8eca51fec2f0.jpg',
    'Yellow backhoe loader digging a service trench beside a road',
  ),
  pickups: representative(
    'https://cdn.magicpatterns.com/patterns/generated-images/32a23783-0a90-479a-9c2e-5f2d238d9ee8.jpg',
    'White 4x4 double-cab and single-cab pickups parked at a site office',
  ),
  plateCompactor: representative(
    'https://cdn.magicpatterns.com/patterns/generated-images/e301ed0c-fc35-4461-91d2-f32b83ceecc2.jpg',
    'Worker operating a plate compactor on paving sand bedding',
  ),
  scaffolding: representative(
    'https://cdn.magicpatterns.com/patterns/generated-images/acb0b30b-07ce-4d15-8934-a83810770804.jpg',
    'Galvanised tube-and-coupler scaffolding around a brick building',
  ),
};
